var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-sidebar"},[_c('headerContentComponent',{attrs:{"openMenu":_vm.openMenu},on:{"click-menu":function($event){return _vm.clickMenu()}}}),_c('bodyContentComponent',{attrs:{"items":_vm.items,"openMenu":_vm.openMenu},on:{"click-route":function($event){return _vm.clickRoute($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }